import {
  CompanyLookup,
  ListItemLookup,
  ListPagedResult,
  PayrollServiceProviderLookup,
  RoleLookup,
} from '@xemplo/gp-types';

type MapFn<T> = (item: T) => ListItemLookup<T>;

function emptyItem<T>(placeholder: string): ListItemLookup<T> {
  return { key: '-1', value: placeholder, original: null };
}

/**
 * The dropdown multi has some interesting behaviour and it always
 * pre-select the first element. To counter this, we add a placeholder
 * item at the beginning of the list. We also pair this with validation
 * rules to ensure it has the correct required behaviour.
 */
function toLookup<T>(data: ListPagedResult<T>, mapItem: MapFn<T>, placeholder: string) {
  const mappedData = (data.result?.rows.map(mapItem) ?? []) as ListItemLookup<T>[];
  mappedData.unshift(emptyItem(placeholder));
  return mappedData;
}

/** Maps the psp paged result from api call to a type that works with the TextDropdownMulti */
export function mapProvidersToLookup(
  data: ListPagedResult<PayrollServiceProviderLookup>
) {
  return toLookup(
    data,
    (item) => ({ key: item.id, value: item.value, original: item }),
    'Select Payroll Provider'
  );
}

/** Maps the company paged result from api call to a type that works with the TextDropdownMulti */
export function mapCompaniesToLookup(data: ListPagedResult<CompanyLookup>) {
  return toLookup(
    data,
    (item) => ({ key: item.id, value: item.value, original: item }),
    'Select Company'
  );
}

/** Maps the role paged result from api call to a type that works with the TextDropdownMulti */
export function mapRolesToLookup(data: ListPagedResult<RoleLookup>) {
  return toLookup(
    data,
    (item) => ({ key: item.id, value: item.description, original: item }),
    'Assign Role'
  );
}
